"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var VideoQualityType;
(function (VideoQualityType) {
    VideoQualityType["AUTOMATIC"] = "Automatic";
    VideoQualityType["SAVE_MOBILE_DATA"] = "Save Mobile data";
    VideoQualityType["WIFI_ONLY"] = "Wifi Only";
})(VideoQualityType = exports.VideoQualityType || (exports.VideoQualityType = {}));
//# sourceMappingURL=VideoQualityType.js.map